<template>
    <div id="page" class="safe-width font-default">
        <common-header class="header"></common-header>
        <!--<main class="main">您好，{{$root.user.meta.username}}！欢迎使用SSO统一认证平台。</main>-->
        <main class="main">
            <cv-table :data="grantApps" c="table primary medium">
                <template v-slot="scope">
                    <cv-table-column label="#" :width="40" :scope="scope">{{scope.index+1}}</cv-table-column>
                    <cv-table-column label="应用名称" :fixed="true" :width="200" :scope="scope">{{(scope.row.app||{}).name}}</cv-table-column>
                    <cv-table-column label="状态" :width="80" :scope="scope">
                        <cv-tag v-if="scope.row.appAccessedUser" :c="'tag ' + enums.appAccessedUser[scope.row.appAccessedUser].level + ' mini'">{{enums.appAccessedUser[scope.row.appAccessedUser].text}}</cv-tag>
                    </cv-table-column>
                    <cv-table-column label="操作" :width="180" :scope="scope">
                            <cv-button @click="revokeGrantApp(scope.index)" c="link primary mini distant-x underline">撤销授权</cv-button>
                    </cv-table-column>
                </template>
            </cv-table>
        </main>
    </div>
</template>

<script>
import CommonHeader from "../../components/CommonHeader.vue";

export default {
    name: 'PageIndex',
    components: {
        CommonHeader
    },
    created() {
        this.loadGrantApp();
    },
    data() {
        return {
            grantApps: [],
            enums: {
                appAccessedUser: {
                    NONE: {
                        text: "未申请",
                        level: "default"
                    },
                    REQUESTED: {
                        text: "待审批",
                        level: "primary"
                    },
                    APPROVED: {
                        text: "可访问",
                        level: "success"
                    },
                    REJECTED: {
                        text: "已拒绝",
                        level: "error"
                    }
                }
            }
        };
    },
    methods: {
        async loadGrantApp() {
            this.grantApps = await this.$remotes.server.appUser.grantApp.list();
        },
        async revokeGrantApp(index) {
            let grantApp = this.grantApps[index];
            await this.$remotes.server.appUser.grantApp.revoke({
                appId: grantApp.app.id
            });
            this.grantApps.splice(index, 1);
        }
    }
}
</script>

<style lang="scss" scoped>
    #page {
        display: flex;
        flex-direction: column;
        min-height: 100%;

        /*&>.main {*/
            /*flex-grow: 1;*/
            /*display: flex;*/
            /*align-items: center;*/
            /*justify-content: center;*/
        /*}*/

        .header {
            flex-shrink: 0;
        }

        .main {
            flex-grow: 1;
            overflow-x: auto;

            .table {
                margin: 1em auto;
                max-width: 1000px;
            }
        }
    }
</style>
